import { FC } from "react";
import classNames from "classnames";

import { LoadingProps } from "./types";

import styles from "./Loading.module.css";


const LOGOS = [
  {
    src: '/loading/1.svg',
    alt: 'Meta',
  },
  {
    src: '/loading/2.svg',
    alt: 'Mistral',
  },
  {
    src: '/loading/3.svg',
    alt: 'Claude',
  },
  {
    src: '/loading/4.svg',
    alt: '',
  },
  {
    src: '/loading/5.svg',
    alt: 'ChatGPT',
  },
  {
    src: '/loading/6.svg',
    alt: 'Gmini',
  },
  {
    src: '/loading/7.svg',
    alt: 'Gemini',
  },
];



const Loading: FC<LoadingProps> = ({ caption, className, style = 'white' }) => {

    return (
      <div className={classNames(styles["loading"], className)} >
        <div className={styles["loading__wrapper"]}>
        {style === 'white' ? (
          [...Array(6)].map((_, index) => (
            <div key={index} className={styles["loading__item"]}>
              <img src={`/loading/loading${index + 1}.svg`} alt="" />
            </div>
          ))
        ) : (
          LOGOS.map((logo) => (
            <div key={logo.alt} className={styles["loading__item"]}>
              <img src={logo.src} alt={logo.alt} />
            </div>
          ))
        )}

        </div>
        {caption && <p 
          className={classNames(styles["loading__label"], style === 'white' ? styles["is-white"] : styles["is-dark"])}>{caption}</p>}
      </div >
    );
};

export default Loading;
